// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD9gq2YlCxmVJ3toeFAUQjTVI5lslgRNAU",
  authDomain: "ds-portfolio-cda56.firebaseapp.com",
  databaseURI: "https://ds-portfolio-cda56-default-rtdb.firebaseio.com/",
  projectId: "ds-portfolio-cda56",
  storageBucket: "ds-portfolio-cda56.appspot.com",
  messagingSenderId: "498490647456",
  appId: "1:498490647456:web:0ffacde4b54aa1628afac5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const database = getDatabase(app);

export default { database }